import React from 'react';
import { useClimate } from '../../contexts/ClimateContext';
import Icon from '../AppIcon';

const WeatherWidget = () => {
  const { temperature, tempUnit, conditions, climate } = useClimate();

  const getClimateIcon = () => {
    switch (climate) {
      case 'snowy': return 'CloudSnow';
      case 'rainy': return 'CloudRain';
      case 'windy': return 'Wind';
      case 'sunny': return 'Sun';
      default: return 'Sun';
    }
  };

  const getClimateColor = () => {
    switch (climate) {
      case 'snowy': return 'text-sky-400';
      case 'rainy': return 'text-blue-400';
      case 'windy': return 'text-slate-400';
      case 'sunny': return 'text-amber-500';
      default: return 'text-amber-500';
    }
  };

  return (
    <div className="flex items-center space-x-3 px-4 py-2 bg-card/40 backdrop-blur-md rounded-2xl border border-white/10 shadow-lg hover:shadow-brand/20 transition-all duration-300 group">
      <div className={`p-1.5 rounded-lg bg-white/5 ${getClimateColor()} group-hover:scale-110 transition-transform duration-300`}>
        <Icon name={getClimateIcon()} size={20} />
      </div>
      <div className="flex flex-col leading-tight">
        <span className="text-sm font-bold text-foreground">
          {temperature}{tempUnit}
        </span>
        <span className="text-[10px] text-text-secondary font-medium uppercase tracking-wider">
          {conditions}
        </span>
      </div>
    </div>
  );
};

export default WeatherWidget;
